import { Show, type VoidComponent } from "solid-js";

type TriggerArkProps = { role?: string } | undefined;

// A select trigger is a combobox, which can't take its name from its content, so it keeps an aria-label. Popover and
// menu triggers are buttons, whose name has to include the visible value instead (WCAG 2.5.3 Label in Name)
const isCombobox = (arkProps: TriggerArkProps): boolean => arkProps?.role === "combobox";

export const triggerAriaLabel = (label: string | undefined, arkProps: TriggerArkProps): string | undefined =>
  isCombobox(arkProps) ? label : undefined;

/** Prefixes the trigger's content with its label for screen readers, unless the trigger is a combobox */
const TriggerLabel: VoidComponent<{ label: string | undefined; arkProps: TriggerArkProps }> = (props) => (
  <Show when={!isCombobox(props.arkProps) && props.label}>{(label) => <span class="sr-only">{label()}: </span>}</Show>
);

export default TriggerLabel;
